export const cacheKeys = {
    jwt: 'jwt.zcty',
    wxuser: 'wxuser.zcty',
    srcMemberId: 'srcMemberId.zcty',
    qdSrcMemberId: 'srcMemberId.zcty'
}
